import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteI18nProvider } from "./site/i18n/useSiteI18n";
import TodayJob from "./components/TodayJob";
import BarcodeReader from "./components/BarcodeReader";
import NotFound from "./components/NotFound";
import Header from "./components/Header";
import Hoewon from "./components/Hoewon";
import RentHistory from "./components/RentHistory";
import Order from "./components/Order";
import Book from "./components/Book";
import Report from "./components/Report";
import { AuthProvider } from "./auth/AuthProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

const HomePageRoute = React.lazy(() => import("./site/routes/HomePageRoute"));
const MatchPageRoute = React.lazy(() => import("./site/routes/MatchPageRoute"));
const LibraryHubRoute = React.lazy(() => import("./site/routes/LibraryHubRoute"));
const LibraryArticleRoute = React.lazy(() => import("./site/routes/LibraryArticleRoute"));

const PublicRouteFallback: React.FC = () => (
  <div className="flex min-h-[40vh] items-center justify-center text-sm text-stone-500">Loading…</div>
);

const AppPublic: React.FC = () => {
  return (
    <SiteI18nProvider>
      <BrowserRouter>
        <div>
          <ToastContainer position="top-right" autoClose={5000} />
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<PublicRouteFallback />}>
                  <HomePageRoute />
                </Suspense>
              }
            />
            <Route
              path="/match"
              element={
                <Suspense fallback={<PublicRouteFallback />}>
                  <MatchPageRoute />
                </Suspense>
              }
            />
            <Route
              path="/library"
              element={
                <Suspense fallback={<PublicRouteFallback />}>
                  <LibraryHubRoute />
                </Suspense>
              }
            />
            <Route
              path="/library/:slug"
              element={
                <Suspense fallback={<PublicRouteFallback />}>
                  <LibraryArticleRoute />
                </Suspense>
              }
            />
            <Route
              path="/today"
              element={
                <AuthProvider>
                  <Header />
                  <TodayJob />
                </AuthProvider>
              }
            />
            <Route
              path="/rent"
              element={
                <AuthProvider>
                  <Header />
                  <BarcodeReader taskType="rent" />
                </AuthProvider>
              }
            />
            <Route
              path="/return"
              element={
                <AuthProvider>
                  <Header />
                  <BarcodeReader taskType="return" />
                </AuthProvider>
              }
            />
            <Route
              path="/hoewon"
              element={
                <AuthProvider>
                  <Header />
                  <Hoewon />
                </AuthProvider>
              }
            />
            <Route
              path="/renthistory"
              element={
                <AuthProvider>
                  <Header />
                  <RentHistory />
                </AuthProvider>
              }
            />
            <Route
              path="/order"
              element={
                <AuthProvider>
                  <Header />
                  <Order />
                </AuthProvider>
              }
            />
            <Route
              path="/book"
              element={
                <AuthProvider>
                  <Header />
                  <Book />
                </AuthProvider>
              }
            />
            <Route
              path="/report"
              element={
                <AuthProvider>
                  <Report />
                </AuthProvider>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </SiteI18nProvider>
  );
};

export default AppPublic;
